import { datadogRum } from '@datadog/browser-rum';
import beforeSend from '~/libs/log/datadog-before-send';

export default defineNuxtPlugin(() => {
  const env = useRuntimeConfig().public;
  if (/^(live|prod|production)$/i.exec(env.environment)) {
    const isIframe = window.self !== window.top;

    datadogRum.init({
      beforeSend,
      applicationId: '735e4b2a-db96-4679-8344-5a0c515c5f06', // BorrowerPortal
      clientToken: 'pubf0032007534d5ef42c600fa00729741c', // BorrowerPortal
      site: 'datadoghq.com',
      service: 'borrowerportalstatic',
      env: 'prod',
      // Specify a version number to identify the deployed version of your application in Datadog
      // version: '1.0.0',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      trackUserInteractions: !isIframe,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
  });
  }
})

